import React, { useEffect, useState } from 'react';
import {
	Form,
	Button,
	Col,
	Table,
	Row,
	Select,
	DatePicker,
	message,
	Input,
} from 'antd';
import {
	fetchImgAuditCrawlSourceList,
	getImgAuditList
} from '../../../api/inspiration';
import AuditModel from './AuditModal';
import './index.less';

const { Option } = Select;
const { RangePicker } = DatePicker;

export const auditStateList = [
	{
		value: -1,
		label: '全部',
	},
	{
		value: 0,
		label: '未审核',
	},
	{
		value: 1,
		label: '已审核',
	},
];

const PAGESIZE = 10;
const ALLSELECT = '全部';

function ImgAudit(props) {
	const { getFieldDecorator, resetFields } = props.form;
	const columns = [
		{
			title: '入库时间',
			key: 'createTime',
			dataIndex: 'createTime',
		},
		{
			title: '图组ID',
			key: 'id',
			dataIndex: 'id',
		},
		{
			title: '爬取来源',
			key: 'crawlSource',
			dataIndex: 'crawlSource',
		},
		{
			title: '爬取词',
			key: 'crawlWord',
			dataIndex: 'crawlWord',
		},
		{
			title: '入库标签',
			key: 'tagWord',
			dataIndex: 'tagWord',
		},
		{
			title: '图片数量',
			key: 'count',
			dataIndex: 'count',
		},
		{
			title: '审核状态',
			key: 'reviewStatus',
			dataIndex: 'reviewStatus',
			render: r => <span>{r == 1 ? '已审核' : '未审核'}</span>
		},
		{
			title: '审核人',
			key: 'reviewerId',
			dataIndex: 'reviewerId',
		},
		{
			title: '操作',
			key: 'operation',
			render: (r, item) => {
				return (
					<>
						<Button
							type='primary'
							icon='edit'
							onClick={() => {
								showModal(item, false);
							}}
							disabled={item.reviewStatus == 1}
						>
							审核
						</Button>
						<Button
							type='danger'
							icon='eye'
							style={{
								backgroundColor: `
										'rgb(137, 191, 85)'
								`,
								marginLeft: 15,
							}}
							onClick={() => showModal(item, true)}
						>
							查看
						</Button>
					</>
				);
			},
		},
	];

	const [sourceList, setSourceList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [total, setTotal] = useState(1);
	const [current, setCurrent] = useState(1);
	const [groupList, setGroupList] = useState([]);
	const [auditModalVisible, setAuditModalVisible] = useState(false);
	const [groupItem, setGroupItem] = useState(null);
	const [update, setUpdate] = useState(false);
	const [isCheck, setCheck] = useState(false); // 是否查看模式

	useEffect(() => {
		getImgAuditCrawlSourceList();
		queryData();
	}, []);

	useEffect(() => {
		if (update) queryData(current);
	}, [update]);

	// 获取爬取来源列表选项
	const getImgAuditCrawlSourceList = async () => {
		const result = await fetchImgAuditCrawlSourceList();
		if (result?.error?.code == 0 && result.data?.length > 0) {
			setSourceList(result.data);
		} else {
			message.error('爬取来源列表接口错误!');
		}
	};

	// 打开审核弹窗
	const showModal = async (item, isCheck) => {
		setCheck(isCheck);
		setGroupItem(item);
		setAuditModalVisible(true);
	};

	const clearAll = () => {
		resetFields();
		queryData();
	};

	// 查询
	const queryData = async page => {
		if (loading) return;
		const { getFieldsValue, getFieldValue } = props.form;
		const values = getFieldsValue();
		const source = getFieldValue('source');
		let parseData = {
			createStartTime: values?.time?.[0]?.format('YYYY-MM-DD') ?? '',
			createEndTime: values?.time?.[1]?.format('YYYY-MM-DD') ?? '',
			reviewStartTime: values?.auditTime?.[0]?.format('YYYY-MM-DD') ?? '',
			reviewEndTime: values?.auditTime?.[1]?.format('YYYY-MM-DD') ?? '',
			reviewStatus: values.status == -1 ? '' : values.status, // 审核状态：未审核-0，已审核-1，全部-空字符串
			crawlSource: source == ALLSELECT ? '' : source, // 爬取来源，全部-空字符串
			page: page ?? 1,
			limit: PAGESIZE,
			keyword: values?.keyword || null,
		};

		setLoading(true);
		const result = await getImgAuditList(parseData);
		if (result?.error?.code === 0 && result.data?.groupList) {
			setCurrent(page ?? 1);
			setTotal(result.data.total ?? 1);
			setGroupList(result.data.groupList);
		} else {
			setTotal(1);
			setGroupList([]);
			setCurrent(1);
			message.error('列表页接口错误!');
		}
		setLoading(false);
		setUpdate(false);
	};

	return (
		<div className='imgAudit'>
			<div className='imgAudit_header'>图片管理&gt;爬取审核</div>
			<div className='imgAudit_operation'>
				<Form>
					<Row gutter={[16, 16]}>
						<Col span={3}>
							<Form.Item>爬取词：{
								getFieldDecorator('keyword', {
								},)
								(<Input width={20} placeholder='请输入搜索词'></Input>)}
							</Form.Item>
						</Col>
						<Col span={3}>
							<Form.Item>
								爬取来源：
								{getFieldDecorator('source', {
									initialValue: ALLSELECT,
									rules: [
										{
											require: true,
											message: '请选择爬取来源',
										},
									],
								})(
									<Select style={{ width: 130 }}>
										<Option value={ALLSELECT}>{ALLSELECT}</Option>
										{sourceList.map(item => {
											return (
												<Option value={item} key={item}>{item}</Option>
											);
										})}
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col span={3}>
							<Form.Item>
								审核状态：
								{getFieldDecorator('status', {
									initialValue: -1,
									rules: [
										{
											required: true,
											message: '请选择审核状态',
										},
									],
								})(
									<Select style={{ width: 130 }}>
										{auditStateList.map((item) => {
											return (
												<Option value={item.value} key={item.label}>
													{item.label}
												</Option>
											);
										})}
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item>
								入库时间：
								{getFieldDecorator('time', {
									rules: [
										{
											require: true,
											validator: (rule, value, callback) => {
												if (!value) {
													callback('请选择入库时间');
												}
											},
										},
									],
								})(
									<RangePicker
										placeholder='请选择入库时间'
										format='YYYY-MM-DD'
										style={{
											width: '300px',
										}}
									/>
								)}
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item>
								审核时间：
								{getFieldDecorator('auditTime', {
									rules: [
										{
											require: true,
											validator: (rule, value, callback) => {
												if (!value) {
													callback('请选择审核时间');
												}
											},
										},
									],
								})(
									<RangePicker
										placeholder='请选择入库时间'
										format='YYYY-MM-DD'
										style={{
											width: '300px',
										}}
									/>
								)}
							</Form.Item>
						</Col>

						<Col span={2} className='btn_wrap'>
							<Form.Item>
								<Button type='danger' icon='delete' loading={loading} onClick={() => clearAll()}>
									清空
								</Button>
							</Form.Item>
							<Form.Item className='search_btn'>
								<Button type='primary' icon='search' loading={loading} onClick={() => queryData()}>
									查询
								</Button>
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</div>
			<div className='auditMarkingTable'>
				<Table
					columns={columns}
					rowKey={(item) => item.id}
					dataSource={groupList}
					bordered
					loading={loading}
					pagination={{
						current,
						total,
						onChange: queryData,
						pageSize: PAGESIZE,
					}}
				/>
			</div>
			<AuditModel visible={auditModalVisible} setVisible={setAuditModalVisible} groupItem={groupItem} onUpdate={setUpdate} isCheck={isCheck} />
		</div>
	);
}

const Index = Form.create({})(ImgAudit);
export default Index;
